import { Component, Inject, OnInit, TemplateRef } from '@angular/core';
import { Router } from '@angular/router';
import { AppComponent } from 'src/app/app.component';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
@Component({
  selector: 'app-chat-leftmenu',
  templateUrl: './chat-leftmenu.component.html',
  styleUrls: ['./chat-leftmenu.component.scss']
})
export class ChatLeftmenuComponent implements OnInit {
  modalRef: BsModalRef;
  bsInlineValue = new Date();
  bsInlineRangeValue: Date[];
  maxDate = new Date();
  userTab: boolean;
  homeTab: boolean = true;
  notificationTab: boolean;
  acountTab: boolean;
  layerTab: boolean;
  toggle1: boolean;
  toggle2: boolean = true;
  toggle3: boolean;
  toggle4: boolean;
  toggle5: boolean;
  toggle6: boolean;
  toggle7: boolean;
  toggle8: boolean;
  toggle9: boolean;
  toggle10: boolean;
  chatTab: boolean;
  contactTab: boolean;
  taskTab: boolean;
  gitTab: boolean;
  staticscard: boolean;
  friendscard: boolean;
  constructor(private router: Router, @Inject(AppComponent) private app: AppComponent, private modalService: BsModalService) {

    this.maxDate.setDate(this.maxDate.getDate() + 7);
    this.bsInlineRangeValue = [this.bsInlineValue, this.maxDate];
  }

  ngOnInit(): void {
  }

  onTab(number) {
    document.getElementById("rmenu").classList.add("open");
    this.chatTab = false;
    this.contactTab = false;
    this.taskTab = false;
    this.gitTab = false;
    if (number == '1') {
      this.chatTab = true;
    }
    else if (number == '2') {
      this.contactTab = true;
    }
    else if (number == '3') {
      this.taskTab = true;
    }
    else if (number == '4') {
      this.gitTab = true;
    }
  }

  onMenuTab(number) {
    // document.getElementById("rmenu").classList.add("open");
    this.userTab = false;
    this.homeTab = false;
    this.notificationTab = false;
    this.acountTab = false;
    this.layerTab = false;
    if (number == '1') {
      this.userTab = true;
    }
    else if (number == '2') {
      this.homeTab = true;
    }
    else if (number == '3') {
      this.notificationTab = true;
    }
    else if (number == '4') {
      this.acountTab = true;
    }

    else if (number == '5') {
      this.layerTab = true;
    }
  }
  onCloseTab(number) {
    document.getElementById("rmenu").classList.remove("open");
    this.chatTab = false;
    this.contactTab = false;
    this.taskTab = false;
    this.gitTab = false;

  }
  onThemeColor() {
    document.getElementById("themeColor").classList.toggle("active");
    if (document.getElementById("themeColor").classList.contains("active")) {
      document.getElementById("main").setAttribute('data-theme', 'dark');
    }
    else {
      document.getElementById("main").setAttribute('data-theme', 'light');
    }
  }

  onMenuOpen() {
    document.getElementsByTagName('body')[0].classList.toggle('open-sidebar-menu');
  }

  colorChange(number) {
    document.getElementById("layout").classList.remove("theme-indigo");
    document.getElementById("layout").classList.remove("theme-cyan");
    document.getElementById("layout").classList.remove("theme-green");
    document.getElementById("layout").classList.remove("theme-blush");
    document.getElementById("layout").classList.remove("theme-dark");
    this.toggle1 = false;
    this.toggle2 = false;
    this.toggle3 = false;
    this.toggle4 = false;
    this.toggle5 = false;
    if (number == '1') {
      document.getElementById("layout").classList.add("theme-indigo");
      this.toggle1 = true;
    }
    else if (number == '2') {
      document.getElementById("layout").classList.add("theme-cyan");
      this.toggle2 = true;
    }
    else if (number == '3') {
      document.getElementById("layout").classList.add("theme-green");
      this.toggle3 = true;
    }
    else if (number == '4') {
      document.getElementById("layout").classList.add("theme-blush");
      this.toggle4 = true;
    }
    else if (number == '5') {
      document.getElementById("layout").classList.add("theme-dark");
      this.toggle5 = true;
    }
  }



  onFontStyle(type) {
    const body = document.getElementsByTagName('body')[0];
    body.classList.remove('font-opensans');
    body.classList.remove('font-montserrat');
    body.classList.remove('font-roboto');
    sessionStorage.setItem("Font1", "");
    if (type == 1) {
      body.classList.add('font-opensans');
      sessionStorage.setItem("Font1", "font-opensans");
    }
    else if (type == 2) {
      body.classList.add('font-montserrat');
      sessionStorage.setItem("Font1", "font-montserrat");
    }
    else if (type == 3) {
      body.classList.add('font-roboto');
      sessionStorage.setItem("Font1", "font-roboto");
    }
  }

  onSubMenuIcon(type) {
    debugger
    const submenuIconclass = document.getElementsByClassName('submenu');
    for (let index = 0; index < submenuIconclass.length; index++) {
      const element = submenuIconclass[index];
      element.classList.remove('list-a');
      element.classList.remove('list-b');
      element.classList.remove('list-c');
      sessionStorage.setItem("MenuIcon", "");
      if (type == 1) {
        element.classList.add('list-a');
        sessionStorage.setItem("MenuIcon", "list-a");
      }
      else if (type == 2) {
        element.classList.add('list-b');
        sessionStorage.setItem("MenuIcon", "list-b");
      }
      else if (type == 3) {
        element.classList.add('list-c');
        sessionStorage.setItem("MenuIcon", "list-c");
      }

    }

  }

  toggleUserMenu() {
    const body = document.getElementsByClassName('user_div')[0];

    if (body.classList.contains('open')) {
      body.classList.remove('open');
    }
    else {
      body.classList.add('open');
    }
    document.getElementsByClassName('overlay')[0].classList.toggle("open");
  }
  toggleSettingMenu() {
    const body = document.getElementsByClassName('right_sidebar')[0];

    if (body.classList.contains('open')) {
      body.classList.remove('open');
    }
    else {
      body.classList.add('open');
    }
    document.getElementsByClassName('overlay')[0].classList.toggle("open");
  }

  onGeneralSetting(type, e) {

    const body = document.getElementsByTagName('body')[0];

    if (type == 1) {
      body.classList.toggle('dark-mode');
      if (e.target.checked) {
        this.toggle1 = true;
        sessionStorage.setItem("Toggle", "true");
      }
      else {
        this.toggle1 = false;
        sessionStorage.setItem("Toggle", "");
      }
    }
    else if (type == 2) {
      if (e.target.checked) {
        this.toggle2 = true;
        sessionStorage.setItem("Toggle2", "true");
      }
      else {
        this.toggle2 = false;
        sessionStorage.setItem("Toggle2", "");
      }
    }
    else if (type == 3) {
      if (e.target.checked) {
        this.toggle3 = true;
        sessionStorage.setItem("Toggle3", "true");
      }
      else {
        this.toggle3 = false;
        sessionStorage.setItem("Toggle3", "");
      }

      document.getElementById("page_top").classList.toggle("top_dark");
      if (e.target.checked) {
        sessionStorage.setItem("HeaderClass", "top_dark");
      }
      else {
        sessionStorage.setItem("HeaderClass", "");
      }
    }
    else if (type == 4) {
      if (e.target.checked) {
        this.toggle4 = true;
        sessionStorage.setItem("Toggle4", "true");
      }
      else {
        this.toggle4 = false;
        sessionStorage.setItem("Toggle4", "");
      }
      document.getElementById("header_top").classList.toggle("dark")
      if (e.target.checked) {
        sessionStorage.setItem("MinSideClass", "dark");
      }
      else {
        sessionStorage.setItem("MinSideClass", "");
      }
    }
    else if (type == 5) {
      if (e.target.checked) {
        this.toggle5 = true;
        sessionStorage.setItem("Toggle5", "true");
      }
      else {
        this.toggle5 = false;
        sessionStorage.setItem("Toggle5", "");
      }
      body.classList.toggle('sidebar_dark');
    }
    else if (type == 6) {
      if (e.target.checked) {
        this.toggle6 = true;
        sessionStorage.setItem("Toggle6", "true");
      }
      else {
        this.toggle6 = false;
        sessionStorage.setItem("Toggle6", "");
      }
      body.classList.toggle('iconcolor');
    }
    else if (type == 7) {
      if (e.target.checked) {
        this.toggle7 = true;
        sessionStorage.setItem("Toggle7", "true");
      }
      else {
        this.toggle7 = false;
        sessionStorage.setItem("Toggle7", "");
      }
      body.classList.toggle('gradient');
    }
    else if (type == 8) {
      if (e.target.checked) {
        this.toggle8 = true;
        sessionStorage.setItem("Toggle8", "true");
      }
      else {
        this.toggle8 = false;
        sessionStorage.setItem("Toggle8", "");
      }
      const className = document.getElementsByClassName('card');
      const className1 = document.getElementsByClassName('btn');
      const className2 = document.getElementsByClassName('progress');
      const classArray = [className, className1, className2];
      for (let index = 0; index < classArray.length; index++) {
        const classIndex = classArray[index];
        for (let index = 0; index < classIndex.length; index++) {
          const element = classIndex[index];
          if (e.target.checked) {
            element.classList.add('box_shadow');
            sessionStorage.setItem("BoxShadow", "box_shadow");
          }
          else {
            element.classList.remove('box_shadow');
            sessionStorage.setItem("BoxShadow", "");
          }
        }
      }

    }
    else if (type == 9) {
      if (e.target.checked) {
        this.toggle9 = true;
        sessionStorage.setItem("Toggle9", "true");
      }
      else {
        this.toggle9 = false;
        sessionStorage.setItem("Toggle9", "");
      }
      body.classList.toggle('rtl');
    }
    else if (type == 10) {
      if (e.target.checked) {
        this.toggle10 = true;
        sessionStorage.setItem("Toggle10", "true");
      }
      else {
        this.toggle10 = false;
        sessionStorage.setItem("Toggle10", "");
      }
      body.classList.toggle('boxlayout');
    }
  }

  toggleMenu() {
    const body = document.getElementsByTagName('body')[0];

    if (body.classList.contains('offcanvas-active')) {
      body.classList.remove('offcanvas-active');
    }
    else {
      body.classList.add('offcanvas-active');
    }
  }
  cToggoleMenu() {
    const body = document.getElementsByTagName('body')[0].classList.remove("offcanvas-active");
    document.getElementsByClassName('overlay')[0].classList.toggle("open");
  }

  CardRemoveStatics() {
    this.staticscard = false;
  }
  CardRemoveFriends() {
    this.friendscard = false;
  }

  openModal(template: TemplateRef<any>) {
    this.modalRef = this.modalService.show(template);
  }

}
